<script>
import AccountPanelMenu from './AccountPanelMenu.vue';
import AccountPanelSignIn from './AccountPanelSignIn.vue';
import Panel from '@maison/components/common/Panel.vue';
import AccountPanel from '@phoenix/mixins/components/myAccount/nav/AccountPanel';

export default {
  components: {
    Panel,
    AccountPanelMenu,
    AccountPanelSignIn,
  },

  mixins: [AccountPanel],
};
</script>

<template>
  <panel
    id="account-panel"
    open-from="end"
    :title="$t('MyAccount.account')"
    :options="{ ...panelOptions, closeAll: true }"
  >
    <template #content>
      <div v-if="!isLoaded" class="center center--and-text">
        <div class="loader loader--dark">
          <div class="loader__inner"></div>
        </div>
      </div>

      <account-panel-sign-in v-else-if="!isLogged" :links="menuLinks.guestLinks" />

      <account-panel-menu v-else :links="menuLinks.loggedLinks" />
    </template>
  </panel>
</template>
